import Card from 'react-bootstrap/Card'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import Table from 'react-bootstrap/Table'

import { EmptyContainer } from '../EmptyContainer'
import { formatCurrency } from './fnbEodReportUtils'

export default function FnbEodReportPayments({ paymentSummary }) {
  const payments = paymentSummary?.payments || []
  const total = paymentSummary?.total ?? 0

  return (
    <Card body className="card--md">
      <h2 className="h5 mb-3">Payment Summary</h2>
      {!payments.length ? (
        <EmptyContainer>
          <p className="mb-0 small text-muted">
            No captured payments for this event, date, and stand.
          </p>
        </EmptyContainer>
      ) : (
        <Row>
          <Col lg={8}>
            <div className="table-container border-bottom-0">
              <Table responsive className="mb-0 fnb-eod-table">
                <thead>
                  <tr>
                    <th className="text-left uppercase text-body">
                      Payment Type
                    </th>
                    <th className="text-right uppercase text-body">Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {payments.map((payment) => (
                    <tr key={payment.paymentMethod}>
                      <td className="text-left">{payment.label}</td>
                      <td className="text-right">
                        {formatCurrency(payment.amount)}
                      </td>
                    </tr>
                  ))}
                  <tr className="fw-semibold">
                    <td className="text-left">Total</td>
                    <td className="text-right">{formatCurrency(total)}</td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </Col>
        </Row>
      )}
    </Card>
  )
}
